<template>
    <div>
        <!-- DIALOG PARA AGREGAR DEPENDENCIA -->
        <v-dialog v-model="mostrar" persistent max-width="700px">  
            <v-card class="elevation-10">
                <v-toolbar >
                    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                    <v-card-title><h3>Asignar horario</h3></v-card-title>
                </v-toolbar>
                <v-card-title>
                <v-container grid-list-md text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md12>
                            <v-autocomplete
                                v-model="horarioSel"
                                :items="listaHorarios"
                                item-text="nombre"
                                item-value="_id"
                                label="Horario"
                                prepend-icon="mdi-city"
                                return-object
                            >
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                </v-container>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="normal" @click="$emit('cancelarAsigHorario')">Cancelar</v-btn>
                    <v-btn small color="primary" @click="asignarHorario()">Agregar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from 'axios'
import _ from 'underscore'

export default {
    name: 'AsignarHorario',
    props:['mostrar','horario','usuario'],
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "permisos",
            "role"
        ])
    },
    data() {
        return {
            id: null,
            horarioSel:{},
            listaHorarios:[],
        }
    },
    created(){
        this.id = this.usuario;
        if( this.horario )
            this.horarioSel = _.clone(this.horario)
        this.enviandoStart();
        axios.get(this.httpURL+'/personal/horarios/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                this.listaHorarios = res.data.horarios;
                // res.data.horarios.forEach(element => {
                //     this.listaHorarios.push({value:element._id,text:element.nombre})
                // });
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        asignarHorario(){
            this.enviandoStart();
            axios.post(this.httpURL+'/personal/horario/asignar/'+this.id,
                {horario:this.horarioSel._id},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    this.$emit('horarioAsignado',this.horarioSel,this.id);
                    this.$emit('cancelarAsigHorario');
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>